// Google Maps JS API yükleyici + geocoding (anahtar site/referrer kısıtlamalı
// olduğu için tüm Google çağrıları TARAYICI tarafında yapılır).
export const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const hasGoogle = () => Boolean(GOOGLE_KEY);

let loaderPromise = null;
let loaderReject = null;
let authFailed = false;

// Google, anahtar/referrer hatasında bu global fonksiyonu çağırır
window.gm_authFailure = () => {
  authFailed = true;
  if (loaderReject) loaderReject(new Error("GOOGLE_AUTH: Anahtar bu site için yetkili değil — Google Cloud Console → Credentials → anahtarınız → Website restrictions bölümüne bu alan adını ekleyin"));
};

export function loadGoogleMaps() {
  if (!GOOGLE_KEY) return Promise.reject(new Error("Google Maps API anahtarı tanımlı değil"));
  if (authFailed) return Promise.reject(new Error("GOOGLE_AUTH: Google Maps anahtarı bu site için yetkili değil — Google Cloud Console'da anahtarın site (referrer) kısıtlamalarına bu alan adını ekleyin"));
  if (window.google?.maps?.Geocoder) return Promise.resolve(window.google);
  if (!loaderPromise) {
    loaderPromise = new Promise((resolve, reject) => {
      loaderReject = (err) => { loaderPromise = null; reject(err); };
      const timer = setTimeout(() => { loaderPromise = null; reject(new Error("Google Maps yükleme zaman aşımı")); }, 10000);
      window.__gmapsReady = () => { clearTimeout(timer); resolve(window.google); };
      const s = document.createElement("script");
      s.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_KEY}&language=tr&region=TR&loading=async&callback=__gmapsReady`;
      s.async = true;
      s.onerror = () => { clearTimeout(timer); loaderPromise = null; reject(new Error("Google Maps yüklenemedi (ağ hatası)")); };
      document.head.appendChild(s);
    });
  }
  return loaderPromise;
}

// Adres → koordinat. Dönen liste: {label, lat, lng, precision, types}
// precision: ROOFTOP (bina) > RANGE_INTERPOLATED (sokak) > GEOMETRIC_CENTER > APPROXIMATE
export async function googleGeocode(address) {
  const g = await loadGoogleMaps();
  const geocoder = new g.maps.Geocoder();
  try {
    // Referrer hatasında Google promise'i asılı bırakabiliyor — 8 sn zaman aşımı şart
    const { results } = await Promise.race([
      geocoder.geocode({ address, region: "TR", componentRestrictions: { country: "TR" } }),
      new Promise((_, rej) => setTimeout(() => rej(new Error(authFailed ? "REQUEST_DENIED (auth)" : "Google geocode zaman aşımı")), 8000)),
    ]);
    if (authFailed) throw new Error("REQUEST_DENIED (auth)");
    return (results || []).map((r) => ({
      label: r.formatted_address,
      lat: r.geometry.location.lat(),
      lng: r.geometry.location.lng(),
      precision: r.geometry.location_type,
      types: r.types || [],
    }));
  } catch (e) {
    const msg = String(e?.message || e);
    if (msg.includes("ZERO_RESULTS")) return [];
    if (msg.includes("REQUEST_DENIED") || msg.includes("zaman aşımı") || authFailed) {
      throw new Error("GOOGLE_AUTH: Anahtar bu site için yetkili değil — Google Cloud Console → Credentials → anahtarınız → Website restrictions bölümüne bu alan adını ekleyin");
    }
    throw e;
  }
}

// Ülke/il gibi çok genel sonuçları eleyip en iyi adayı döner
export const bestGeocodeResult = (results) =>
  results.find((r) => !r.types.includes("country") && !r.types.includes("administrative_area_level_1")) || null;
